<template>
  <v-dialog :value="show" :persistent="true" max-width="500px" @input="$emit('close')">
    <v-card>
      <v-toolbar flat class="k-orange-linear">
        <v-toolbar-title class="white--text pl-4 py-3">
          Asignar operador
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap py-2 px-4>
          <v-flex xs12>
            <v-select
              v-model="type"
              :items="types"
              item-value="value"
              item-text="name"
              v-validate="'required'"
              data-vv-name="type"
              data-vv-as="Reasignar a"
              :error-messages="errors.collect('type')"
              label="Reasignar a"
              color="black">
            </v-select>
          </v-flex>
          <v-flex xs12 v-if="type === 'operator'">
            <v-select
              v-model="user"
              :items="operators"
              item-value="id"
              item-text="name"
              v-validate="'required'"
              data-vv-name="user"
              data-vv-as="usuario"
              :error-messages="errors.collect('user')"
              label="Reasignar a"
              color="black">
            </v-select>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout>
          <v-flex :class="{ 'text-xs-right': true }" pr-4>
            <v-btn flat color="black" @click="$emit('close')">
              CANCELAR
            </v-btn>
            <v-btn class="k-orange-linear-text" flat @click="save" :disabled="errors.any()">
              GUARDAR
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    inject: ['$validator'],
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      selectedChat: {
        type: Number,
        default: -1,
      },
    },
    mounted() {
      this.axios.get('users/operators').then(({ data }) => {
        this.users = data;
      });
    },
    data() {
      return {
        data: '',
        type: '',
        user: '',
        types: [
          {
            name: 'Operador',
            value: 'operator',
          },
          {
            name: 'Automatico',
            value: 'automatic',
          },
        ],
        users: [],
      };
    },
    computed: {
      operators() {
        return this.users.map((item) => {
          // eslint-disable-next-line
          item.name = `${item.first_name} ${item.last_name} - ${item.role.display_name}`;
          return item;
        });
      },
    },
    methods: {
      save() {
        // soon
        if (this.selectedChat !== -1) {
          this.axios.post(`chats_center/reasign/${this.selectedChat}`, {
            type: this.type,
            user: this.user,
          }).then(() => {
            this.$emit('close');
          });
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/chat_center/ReasignOperatorDialog.vue